module.exports = __webpack_public_path__ + "img/logo-cap.e820beda.svg";